module.exports = __webpack_public_path__ + "img/file-icon_mp4.de9a634f.svg";